"use client";
import { getRelativePathFromLink } from "./url";
import { Post } from "@aleksundshantu/aunds-deepl-unmute-types/client";

/**
 * **Path Translator**
 * @returns *available translations for the current page*
 */
export const pathTranslator = (post: Post) => {
  const availableTranslations: { lang: string; path: string }[] = [];

  if (!post) return availableTranslations;

  if (post.wpml_translations) {
    post.wpml_translations.map((info) => {
      if (
        (process.env.NEXT_PUBLIC_LOCALES?.split(",") ?? ["de"]).some(
          (l) => l === info.locale.split("_")[0],
        )
      ) {
        availableTranslations.push({
          lang: info.locale.split("_")[0],
          path: getRelativePathFromLink(info.href),
        });
      }
    });
  }

  return availableTranslations;
};

export const dynamicPath = (href: string) => {
  const url = href.split("/");
  if (url[url.length - 1] !== "") {
    // Url has no / at the end
    return url[url.length - 1];
  } else {
    // Url has / at the end
    return url[url.length - 2];
  }
};
